// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__K9gDz","inner":"PageNotFound_inner__awiHP","goBack":"PageNotFound_goBack__QGZNU"};